import $ from "jquery";

export default class AjaxBlocking {
    isBlockedOnAjax(element) {
        const isBlocked =
            element.classList.contains("processing") ||
            $(element).parents(".processing").length;
        return isBlocked;
    }

    blockOnAjax(element) {
        if (!this.isBlockedOnAjax(element)) {
            element.classList.add("processing");
            $(element).block({
                message: null,
                overlayCSS: {
                    background: "#fff",
                    opacity: 0.6,
                },
            });
        }
    }

    unblockOnAjax(element) {
        element.classList.remove("processing");
        $(element).unblock();
    }
}
